import { call, put, takeLatest, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import { getLoyaltyPointsAvailability } from './api';
import {
  GET_LOYALTY_POINTS_AVAILABILITY_REQUEST,
  GET_LOYALTY_POINTS_AVAILABILITY_SUCCESS,
  LOYALTY_POINTS_AVAILABILITY_REQUESTING,
  RESET_LOYALTY_POINTS_AVAILABILITY_ISFETCHING
} from './constants';

function* getPointAvailability(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: LOYALTY_POINTS_AVAILABILITY_REQUESTING });
    const response = yield call(getLoyaltyPointsAvailability, action.cartId);
    yield put({
      type: GET_LOYALTY_POINTS_AVAILABILITY_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_LOYALTY_POINTS_AVAILABILITY_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* watchList() {
  yield takeLatest(
    GET_LOYALTY_POINTS_AVAILABILITY_REQUEST,
    getPointAvailability
  );
}

export default function* loyaltyPointsAvailabiltySagas() {
  yield all([watchList()]);
}
